import type { CashDenominationRowDto } from './cash-denominations.dto.js';

export const cashExpenseStatusValues = ['active', 'voided'] as const;
export type CashExpenseStatus = (typeof cashExpenseStatusValues)[number];

export const cashExpenseSourceTypeValues = ['drawer', 'vault', 'treasury'] as const;
export type CashExpenseSourceType = (typeof cashExpenseSourceTypeValues)[number];

// Monetary amounts are in minor units (e.g., cents).
export interface CashExpenseDto {
  id: string;
  operationId: string | null;
  requestHash: string | null;
  replacesExpenseId: string | null;
  companyId: string;
  sourceType: CashExpenseSourceType;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  cashLocationId: string;
  cashSessionId: string | null;
  categoryId: string | null;
  amount: number;
  description: string;
  status: CashExpenseStatus;
  createdByUserId: string;
  voidedByUserId: string | null;
  voidReason: string | null;
  movementId: string;
  reversalMovementId: string | null;
  occurredAt: string;
  voidedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCashExpenseRequest {
  companyId: string;
  operationId: string;
  sourceType?: CashExpenseSourceType;
  stationId?: string | null;
  storeId?: string;
  locationId?: string;
  cashLocationId: string;
  cashSessionId?: string | null;
  categoryId?: string | null;
  amount: number;
  description: string;
  occurredAt?: string;
  denominations?: CashDenominationRowDto[] | null;
}

export interface CreateCashExpenseResponse {
  cashExpense: CashExpenseDto;
  warnings?: string[];
}

export interface VoidCashExpenseRequest {
  companyId: string;
  operationId: string;
  expenseId: string;
  sourceType?: CashExpenseSourceType;
  stationId?: string | null;
  storeId?: string;
  locationId?: string;
  voidReason?: string | null;
  occurredAt?: string;
}

export interface VoidCashExpenseResponse {
  cashExpense: CashExpenseDto;
}

export interface ListCashExpensesRequest {
  companyId: string;
  sourceType?: CashExpenseSourceType;
  storeId?: string;
  locationId?: string;
  stationId?: string;
  cashLocationId?: string;
  cashSessionId?: string;
  categoryId?: string;
  status?: CashExpenseStatus;
  from?: string;
  to?: string;
}

export interface ListCashExpensesResponse {
  items: CashExpenseDto[];
}
